import { Spacing, Background, Width } from "@/app/(custom-header)/winners-template/LayoutTokens";

export const spacingMap: Record<Spacing, string> = {
  none: "",
  sm: "py-4 lg:py-6",
  md: "py-6 lg:py-10",
  lg: "py-10 lg:py-16",
  xl: "py-16 lg:py-24",
};

export const backgroundMap: Record<Background, string> = {
  none: "",
  white: "bg-white",
  gray: "bg-gray-100",
  dark: "bg-neutral-900 text-white",
  ellipses: "bg-ellipses",
};

export const widthMap: Record<Width, string> = {
  full: "w-full",
  contained: "w-full max-w-[1360px] mx-auto",
};
